export function getImageType(src) {
    return src.includes('png') ? 'image/png' : 'image/jpeg';
}
export function getWebpSrc(src) {
    var amountToSlice = src.includes('jpeg') ? 4 : 3;
    var webpPath = "".concat(src.slice(0, src.length - amountToSlice), "webp");
    return webpPath;
}
